import { render, staticRenderFns } from "./Dicom3dViewer.vue?vue&type=template&id=566169c0&"
import script from "./Dicom3dViewer.vue?vue&type=script&lang=js&"
export * from "./Dicom3dViewer.vue?vue&type=script&lang=js&"
import style0 from "./Dicom3dViewer.vue?vue&type=style&index=0&id=566169c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports